import Axios from "../../../utils/axios";

export const getCollections = (data) => {
    return (dispatch) => {
        Axios.get("/raffle-collections", dispatch, "GET_COLLECTIONS", data)
            .then((response) => {
                return response.response.data
            });
    };
};

export const createCollection = (data) => {
    return (dispatch) => {
        return Axios
            .post("/raffle-collection", dispatch, "CREATE_COLLECTION", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: data.event_id
                    };
                    dispatch(getCollections(param));
                }
                return response;
            });
    };
};

export const updateCollection = (data) => {
    return (dispatch) => {
        return Axios
            .post("/raffle-collection/" + data.id, dispatch, "UPDATE_COLLECTION", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: data.event_id
                    };
                    dispatch(getCollections(param));
                }
                return response;
            });
    };
};

export const deleteCollection = (data) => {
    return (dispatch) => {
        return Axios
            .delete("/raffle-collection/" + data.id, dispatch, "DELETE_COLLECTION")
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: data.event_id
                    };
                    dispatch(getCollections(param));
                }
                return response;
            });
    };
};